export default __webpack_public_path__ + "static/erzurumspor-fk-e5bc62a887084ba62f513663fd9ee351.png";